import React from "react";
import LeftNavbar from "../global/LeftNavbar";
import Header from "./Header";
import Profile from "./Profile";
import { useTranslation } from "react-i18next";

export default function MyAccount() {
    const { t } = useTranslation();
    return (
        <div className="body bg-color">
            <div id="container" className="dashboard-wrapper">
                <Header />
                <LeftNavbar />
                <section className="dashboard-content">
                    <div id="content" className="dashboard-wrap">
                        <div className="my-account-page">
                            <div className="project-heading userprofile-heading">
                                <h3>{t("my_account.my_account_of")}</h3>
                                <span>{t("my_account.view_personal_info_heading")}</span>
                            </div>
                            <div className="listing-tab-block flex">
                                <ul className="listing-tab-link flex" role="tablist">
                                    <li role="none">
                                        <button role="tab" className="active">
                                            {t("my_account.profile")}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="white-bg">
                                <div className="profile-tab-content show">
                                    <Profile />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}